module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7y9BS"))).then(() => parcelRequire('d0iPb'));